export default "__VITE_ASSET__86c3d613__"